module.exports = __webpack_public_path__ + "img/高老庄.99571a88.png";